(function () {
  'use strict';

  if (window.PGProductUxV35R2) return;
  window.PGProductUxV35R2 = true;

  var state = {
    currentLabel: '',
    observer: null
  };

  function normalise(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function addStartingPrice(wrapper) {
    if (!wrapper || document.querySelector('.pg-product-starting-price')) return;

    var title = document.querySelector('.product__details--product-page h1.product_name');
    var source = document.querySelector('script[data-pg-product-starting-price]');
    var formatted = '';
    try {
      formatted = source ? normalise(JSON.parse(source.textContent || '""')) : '';
    } catch (error) {
      formatted = source ? normalise(source.textContent) : '';
    }
    if (!title || !formatted) return;

    var price = document.createElement('p');
    var amount = document.createElement('strong');
    var was = document.createElement('s');
    var save = document.createElement('span');
    price.className = 'pg-product-starting-price';
    price.setAttribute('data-pg-title-price', '');
    price.setAttribute('aria-label', 'Selected price ' + formatted);
    amount.setAttribute('data-pg-title-amount', '');
    was.setAttribute('data-pg-title-was', '');
    save.setAttribute('data-pg-title-save', '');
    amount.textContent = formatted;
    was.hidden = true;
    save.hidden = true;
    price.appendChild(amount);
    price.appendChild(was);
    price.appendChild(save);
    title.insertAdjacentElement('afterend', price);
  }

  function bringNextButtonForward(wrapper) {
    if (!wrapper) return;
    var footer = wrapper.querySelector('.pg-cfg-footer');
    var row = wrapper.querySelector('.pg-cfg-btnrow');
    var summary = wrapper.querySelector('.pg-choice-summary');
    if (!footer || !row || !summary) return;

    row.classList.add('pg-cfg-btnrow--near-step');

    if (row.parentElement !== footer || footer.firstElementChild !== row) {
      footer.insertBefore(row, footer.firstChild);
    }

    if (summary.parentElement !== footer || row.nextElementSibling !== summary) {
      footer.insertBefore(summary, row.nextSibling);
    }

    var reassurance = document.querySelector('[data-pg-extras] .pg-extras__trust');
    var instalments = footer.querySelector('.pg-cfg-instal');
    if (reassurance && instalments) {
      if (reassurance.parentElement !== footer || instalments.nextElementSibling !== reassurance) {
        footer.insertBefore(reassurance, instalments.nextSibling);
      }
    }
  }

  function currentStepLabel(wrapper) {
    var active = wrapper && wrapper.querySelector('.pg-cfg-step-dot.is-active .pg-cfg-step-dot__label');
    return normalise(active && active.textContent);
  }

  function ensureGuideSlot(wrapper) {
    if (!wrapper) return null;
    var existing = wrapper.querySelector('.pg-step-guide-slot');
    if (existing) return existing;

    var status = wrapper.querySelector('.pg-guide-status');
    if (!status) return null;

    var slot = document.createElement('div');
    slot.className = 'pg-step-guide-slot';
    slot.hidden = true;
    status.insertAdjacentElement('afterend', slot);
    return slot;
  }

  function placeSizeGuide(wrapper) {
    if (!wrapper) return;
    var slot = ensureGuideSlot(wrapper);
    if (!slot) return;

    var trigger = document.querySelector('.product__details--product-page .pg-inline-guide-trigger--size, .product__details--product-page .pg-size-chart-link');
    if (trigger && trigger.parentElement !== slot) slot.appendChild(trigger);

    var isSizing = /siz/i.test(state.currentLabel || currentStepLabel(wrapper));
    slot.hidden = !isSizing || !slot.querySelector('.pg-inline-guide-trigger--size, .pg-size-chart-link');
  }

  function enhanceReviewLink() {
    var titleBlock = document.querySelector('.product__details--product-page .product-block--title');
    if (!titleBlock) return;

    var link = titleBlock.querySelector('a[href="#looxReviews"]');
    if (!link) return;

    link.classList.add('pg-product-review-link');
    if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', 'Read customer reviews');

    var sibling = link.nextElementSibling;
    if (sibling && sibling.classList.contains('shopify-product-reviews-badge')) {
      link.appendChild(sibling);
    }

    if (link.dataset.pgReviewJump === 'true') return;
    link.dataset.pgReviewJump = 'true';
    link.addEventListener('click', function (event) {
      var target = document.getElementById('looxReviews') || document.querySelector('.loox-reviews-default');
      if (!target) return;
      event.preventDefault();
      target.setAttribute('tabindex', '-1');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(function () {
        try { target.focus({ preventScroll: true }); } catch (error) {}
      }, 500);
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#looxReviews');
      }
    });
  }

  function trimDuplicatePhotoFaq() {
    document.querySelectorAll('.pg-faq__q').forEach(function (button) {
      var label = normalise(button.textContent).toLowerCase();
      if (label !== 'what makes a good photo?') return;
      var item = button.closest('.pg-faq__item');
      if (item) item.remove();
    });
  }

  function observeConfigurator(wrapper) {
    if (!wrapper || wrapper.dataset.pgFabObserver === 'true') return;
    wrapper.dataset.pgFabObserver = 'true';

    function setVisible(isVisible) {
      document.body.classList.toggle('pg-configurator-in-view', Boolean(isVisible));
    }

    if (!('IntersectionObserver' in window)) {
      setVisible(true);
      return;
    }

    state.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === wrapper) setVisible(entry.isIntersecting);
      });
    }, { threshold: 0.04, rootMargin: '-40px 0px -12% 0px' });

    state.observer.observe(wrapper);
  }

  function apply() {
    var wrapper = document.querySelector('[data-product-form]');
    if (!wrapper) return;

    if (!state.currentLabel) state.currentLabel = currentStepLabel(wrapper);
    addStartingPrice(wrapper);
    bringNextButtonForward(wrapper);
    placeSizeGuide(wrapper);
    enhanceReviewLink();
    trimDuplicatePhotoFaq();
    observeConfigurator(wrapper);
  }

  function boot() {
    apply();
    [180, 650, 1300, 2200, 3600].forEach(function (delay) {
      window.setTimeout(apply, delay);
    });
  }

  document.addEventListener('pg-cfg-step', function (event) {
    state.currentLabel = normalise(event.detail && event.detail.label);
    window.setTimeout(function () {
      var wrapper = document.querySelector('[data-product-form]');
      bringNextButtonForward(wrapper);
      placeSizeGuide(wrapper);
    }, 0);
  });

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(boot, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
